import ClaimDeclarationsService from "@/api/services/claimDeclarations";
import ClaimsService from "@/api/services/claims";
import { toCamelCase } from "@estaly/ui";

// Handles two BO flows: listing a claim's declarations (`fetchIndex`) and the
// "update declaration on behalf of customer" form. The state shape mirrors
// customer's `claimDeclarations` store so shared @estaly/ui step components can
// `mapState("claimDeclarations", ...)`; unused fields stay at their defaults.
const initialState = {
  declarationId: null,
  declaration: null,
  contractCategory: null,
  coverages: [],
  products: [],
  planSaleContractType: null,
  coverage: null,
  occurredAtHome: null,
  fraudulentSimUse: null,
  isInvoiceHolder: null,
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setDeclarationId(state, declarationId) {
      state.declarationId = declarationId;
    },
    resetDeclarationId(state) {
      state.declarationId = null;
    },
    setCoverage(state, coverage) {
      state.coverage = coverage;
    },
    setOccurredAtHome(state, occurredAtHome) {
      state.occurredAtHome = occurredAtHome;
    },
    setFraudulentSimUse(state, fraudulentSimUse) {
      state.fraudulentSimUse = fraudulentSimUse;
    },
    setDeclaration(state, declaration) {
      state.declaration = declaration;
    },
    setIsInvoiceHolder(state, isInvoiceHolder) {
      state.isInvoiceHolder = isInvoiceHolder;
    },
    resetIndex(state) {
      state.index = [];
      state.currentPage = 1;
      state.totalPages = 0;
      state.totalCount = 0;
    },
    setIndex(state, data) {
      state.index = data.records;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async createNewVersion({ commit, dispatch }, { claimDeclarationId }) {
      commit("resetDeclarationId");
      const response = await ClaimDeclarationsService.createNewVersion(claimDeclarationId);
      if (!response?.success) {
        dispatch(
          "notifications/notify",
          {
            category: "simple",
            type: "error",
            title: "Erreur",
            text: "Impossible de créer une nouvelle version de la déclaration.",
          },
          { root: true },
        );
        return;
      }
      commit("setDeclarationId", response.data.id);
    },
    async fetchDeclaration({ state, commit }) {
      if (!state.declarationId) {
        commit("setDeclaration", null);
        return;
      }
      const response = await ClaimDeclarationsService.show(state.declarationId);
      if (!response?.success) {
        commit("setDeclaration", null);
        return;
      }
      commit("setDeclaration", toCamelCase(response.data));
    },
    async update({ state }, { formData, signal }) {
      return await ClaimDeclarationsService.update(state.declarationId, formData, signal);
    },
    async fetchIndex({ commit }, { claimId, page, includes = [] } = {}) {
      const response = await ClaimsService.fetchDeclarations({ claimId, page, includes });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
    async retryAiAnalysis({ dispatch }, { declarationId, analysisType }) {
      let response;
      try {
        response = await ClaimDeclarationsService.retryAiAnalysis(declarationId, analysisType);
      } catch {
        response = null;
      }
      if (!response?.success) {
        dispatch(
          "notifications/notify",
          {
            category: "simple",
            type: "error",
            title: "Erreur",
            text: "Impossible de relancer l'analyse IA.",
          },
          { root: true },
        );
        return { success: false };
      }
      return { success: true };
    },
  },
};
